import * as React from 'react';

/** The squared X logo used in the profile socials row. `svg/XIcon` is a different,
 *  larger-radius mark that other screens already depend on, so this sits alongside it. */
export default function XTwitter({
  className,
  viewBox = '0 0 16 16',
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg className={className} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.28571 0C1.025 0 0 1.025 0 2.28571V13.7143C0 14.975 1.025 16 2.28571 16H13.7143C14.975 16 16 14.975 16 13.7143V2.28571C16 1.025 14.975 0 13.7143 0H2.28571ZM12.8964 3L9.18929 7.23571L13.55 13H10.1357L7.46429 9.50357L4.40357 13H2.70714L6.67143 8.46786L2.48929 3H5.98929L8.40714 6.19643L11.2 3H12.8964ZM11.5464 11.9857L5.47857 3.96071H4.46786L10.6036 11.9857H11.5429H11.5464Z"
        fill="currentColor"
      />
    </svg>
  );
}
